import React, { Fragment, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';

import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Brightness6OutlinedIcon from '@material-ui/icons/Brightness6Outlined';
import Switch from '@material-ui/core/Switch';

import useStyles from './Style';

import List from '@base/Drawer/List';

import MenuRoute from '@routes/RoutesConfig';

const ThemeMode = (props) => {
  const classes = useStyles();

  const [checked, setChecked] = useState(props.darkMode)

  const handleChange = () => {
    setChecked(!checked);
    props.setDarkMode(!checked);
  };

  return (
    <div className={classes.darkMode}>
      <Brightness6OutlinedIcon />
      <Switch
        checked={checked}
        onChange={handleChange}
        color="primary"
        name="darkMode"
      />
    </div>
  );
}

const DrawerLeft = (props) => {
  const classes = useStyles();
  const menuRoute = MenuRoute();
  const theme = useTheme();

  let listItems = menuRoute.map( (menu, key) => {
      return (
        <Fragment key={key} >
          <List items={menu.items} category={menu.category} />
        </Fragment>
      )
  });

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: props.open,
        [classes.drawerClose]: !props.open,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: props.open,
          [classes.drawerClose]: !props.open,
        }),
      }}
    >
      <div className={classes.toolbar}>
        <IconButton onClick={props.click}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <Divider />

      { listItems }

      <div className={classes.drawerEnd}>
        <ThemeMode
          darkMode={props.darkMode}
          setDarkMode={props.setDarkMode}
        />
      </div>
    </Drawer>
  );
}

export default DrawerLeft;
